// theme.ts
import { createTheme } from "@mui/material/styles";
import { colorVariables } from "./utils/colorVariable";

const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
  palette: {
    primary: {
      main: colorVariables.primary,
    },
    secondary: {
      main: colorVariables.secondary,
    },
    info: {
      main: "#007bff",
    },
    success: {
      main: "#28a745",
    },
    error: {
      main: colorVariables.red,
    },
    warning: {
      main: "#ffc107",
    },
    background: {
      default: "#fff", // Optional: global background color
    },
  },
});

export default theme;
